import React from 'react';
import { Heart } from 'lucide-react';
import { ThemeConfig } from './../types';

interface LoginScreenProps {
  theme: ThemeConfig;
  onSignIn: () => void;
}

const LoginScreen: React.FC<LoginScreenProps> = ({ theme, onSignIn }) => {
  return (
    <div className={`min-h-screen ${theme.primary} flex items-center justify-center p-4`}>
      <div className={`${theme.cardBg} backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-2xl ${theme.shadow} max-w-md w-full`}>
        <div className="text-center mb-8">
          <Heart className={`w-16 h-16 mx-auto mb-4 ${theme.text}`} fill="currentColor" />
          <h1 className={`text-3xl font-bold ${theme.text} mb-2`}>
            Welcome to Yuk's Virtual Space
          </h1>
          <p className={`${theme.textLight}`}>
            OAuth since Yuk loves oauth :)
          </p>
        </div>
        
        <button
          onClick={onSignIn}
          className={`w-full ${theme.button} text-white py-4 px-6 rounded-xl font-semibold transition-all transform hover:scale-105 shadow-lg flex items-center justify-center gap-3`}
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="white">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Sign in with Google
        </button>

        {/* <p className={`text-xs ${theme.textLight} text-center mt-6`}>
          This site is just for you. Only your Google account can access it. 🔒
        </p> */}
      </div>
    </div>
  );
};

export default LoginScreen;